import {NotifyAlertComponent} from './components/header/notify-alert/notify-alert.component';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ErrorComponent} from './components/error/error.component';
import {HeaderComponent} from './components/header/enterprise-header/header.component';
import {BreadcrumbsComponent} from './components/breadcrumbs/breadcrumbs.component';
import {RouterModule} from '@angular/router';
import {CheckInputNumberDirective} from './directive/check-input-number.directive';
import {BytePipe} from './pipe/byte.pipe';
import {NumericDirective} from './directive/numeric.directive';
import {TranslateModule} from '@ngx-translate/core';
import {UploadMultiFileComponent} from './components/upload-multi-file/upload-multi-file.component';
import {UploadFileComponent} from './components/upload-file/upload-file.component';
import {PdfViewerComponent} from './components/pdf-viewer/pdf-viewer.component';
import {MaterialModule} from '../core/material';
import {ConfirmDeactivateGuard} from '../core/guards/confirm-deactivate.guard';
import {DateformatPipe} from './pipe/dateformat.pipe';
import {FocusFirstElementDirective} from './directive/focus-first-element.directive';
import {CheckSpaceDirective} from './directive/check-space.directive';
import {CheckMiddleSpaceDirective} from './directive/check-middle-space.directive';
import {CheckUserNameDirective} from './directive/check-input-user.directive';
import {CheckDepartmentCodeDirective} from './directive/check-input-department.directive';
import {CheckCertificateNoDirective} from './directive/check-certificate-no.directive';
import {PageNotFoundComponent} from '../modules/page-not-found/page-not-found.component';
import {FooterComponent} from './components/footer/footer.component';
import {PaginationComponent} from './components/pagination/pagination.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CheckPhoneDirective} from './directive/check-phone.directive';
import {EmailvalidatorDirective} from './directive/emailvalidator.directive';
import {ViewPdfComponent} from './components/view-pdf/view-pdf.component';
import {EnterpriseSidebarComponent} from './components/sidebar/enterprise-sidebar/enterprise-sidebar.component';
import {HeaderSidebarComponent} from 'src/app/shared/components/sidebar/header-sidebar/header-sidebar.component';
import {CdkDetailRowDirective} from './directive/cdk-detail-row.directive';
import {TruncatePipe} from './pipe/TruncatePipe';
import {ViewDocumentReferenceComponent} from './components/view-document-reference/view-document-reference.component';
import {DateformatPipeTime} from './pipe/dateformatTime.pipe';
import {DateformatPipeTimeWithNoSeconds} from './pipe/dateformatTimeWithNoSeconds.pipe';
import {NoSanitizePipe} from './pipe/no-sanitize.pipe';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {NgxMatSelectSearchModule} from 'ngx-mat-select-search';
import {DialogDraggableTitleDirective} from './directive/dialog-draggable-title.directive';
import {MatFormFieldModule} from '@angular/material';
import {DialogDraggableSpecialDirective} from './directive/dialog-draggable-special.directive';
import {SautocompleteComponent} from './components/sautocomplete/sautocomplete.component';
import {AutofocusDirective} from './directive/auto-focus.directive';
import {ChangePasswordComponent} from './components/change-password/change-password.component';
import {MustMatchDirective} from './directive/must-match.directive';
import {PasswordPatternDirective} from './directive/password-pattern.directive';
import {NotMatchDirective} from './directive/not-match.directive';
import {DragAndDropFileDirective} from './directive/drag-and-drop-file.directive';
import {PublicHeaderComponent} from './components/header/public-header/public-header.component';
import {DragDropUploadComponent} from './components/drag-drop-upload/drag-drop-upload.component';
import {ReplaceStringPipe} from './pipe/replace-string.pipe';
import {LandingpageHeaderComponent} from './components/header/landingpage-header/landingpage-header.component';
import {LandingpageFooterComponent} from './components/footer/landingpage-footer/landingpage-footer.component';
import {LandingpageHeaderChildComponent} from './components/header/landingpage-header-child/landingpage-header-child.component';
import {CounterDirective} from './directive/counter.directive';
import {Ng4LoadingSpinnerModule} from 'ng4-loading-spinner';
import {CanvasComponent} from './components/canvas/canvas.component';
import {PageNotFoundNoAccessComponent} from './components/page-not-found-no-access/page-not-found-no-access.component';
import {NgxExtendedPdfViewerModule} from 'ngx-extended-pdf-viewer';
import {CurrencyMaskPipe} from './pipe/currencyMask.pipe';
import {QuestionLoginComponent} from './components/question-login/question-login.component';
import {ErpSContractComponent} from './components/erp-scontract/erp-scontract.component';

import {ResetPasswordComponent} from '../modules/reset-password/reset-password.component';
import {ResetPasswordExistsComponent} from '../modules/reset-password/reset-password-exists/reset-password-exists.component';
import {WarningWithSkipComponent} from './components/warning-with-skip/warning-with-skip.component';
import {MarkDownComponent} from './components/mark-down/mark-down.component';
import {ClickOutsideDirective} from './directive/click-outside.directive';
import {WarningErrorFileComponent} from './components/warning-error-file/warning-error-file.component';
import {ProcessingComponent} from './components/header/processing-header/processing.component';
import {CheckProcedureNameDirective} from './directive/check-procedure-name.directive';
import {WarningSessionTimeoutComponent} from './components/warning-session-timeout/warning-session-timeout.component';
import {NotifySessionTimeoutComponent} from './components/notify-session-timeout/notify-session-timeout.component';
import {NotifyWarningComponent} from './components/notify-warning/notify-warning.component';
import {WarningHasTokenComponent} from './components/warning-has-token/warning-has-token.component';
import { NotEnoughAlertComponent } from './components/not-enough-alert/not-enough-alert.component';
import { CheckParamDirective } from './directive/check-input-param.directive';
import { WaringSignatureComponent } from './components/waring-signature/waring-signature.component';
import {ConfirmForwardComponent} from "./components/confirm-forward/confirm-forward.component";
import { AlertEkycComponent } from './components/alert-ekyc/alert-ekyc.component';
import { FeedbackComponent } from './components/feedback/feedback.component';
import { DocumentDownloadDialogComponent } from './components/document-download-dialog/document-download-dialog.component';
import { DocumentDownloadSuccessDialogComponent } from './components/document-download-success-dialog/document-download-success-dialog.component';
import { DocumentDownloadFalseDialogComponent } from './components/document-download-false-dialog/document-download-false-dialog.component';
import { HandleTransactionResultDialogComponent } from './components/handle-transaction-result-dialog/handle-transaction-result-dialog.component';
import { HandleTransactionDetailDialogComponent } from './components/handle-transaction-detail-dialog/handle-transaction-detail-dialog.component';
import {DateTime} from './pipe/date-format-time.pipe';
import { KycCustomerInforComponent } from './components/kyc-customer-infor/kyc-customer-infor.component';
import {NgZorroAntdModule} from "ng-zorro-antd";
import {DateYearMonthDayPipe} from "./pipe/dateYearMonthDay.pipe";
import { NotifyExportDataCustomerComponent } from './components/notify-export-data-customer-dialog/notify-export-data-customer-dialog.component';
import { NotifyExportDataCustomerSuccessComponent } from './components/notify-export-data-customer-success-dialog/notify-export-data-customer-success-dialog.component';
import { PageErrorCodeComponent } from '../modules/page-error-code/page-error-code.component';
import { PageAnnouncementComponent } from '../modules/page-announcement/page-announcement.component';
import { PageErrorExpireComponent } from '../modules/page-error-expire/page-error-expire.component';
import { WarningNotChangeContractCodeComponent } from './components/warning-not-change-contract-code/warning-not-change-contract-code.component';
import { SmsWarningComponent } from './components/sms-warning/sms-warning.component';
import { SsoLoginWarningComponent } from './components/sso-login-warning/sso-login-warning.component';
import { AddApproverDialogComponent } from './components/add-approver-dialog/add-approver-dialog.component';
import { ApproveActionDialogComponent } from './components/approve-action-dialog/approve-action-dialog.component';
import { ForwardSignDialogComponent } from './components/forward-sign-dialog/forward-sign-dialog.component';
import { SelectVersionComponent } from './components/select-version/select-version.component';
import { VerifyEnterpriceDialogComponent } from './components/verify-enterprice-dialog/verify-enterprice-dialog.component';
import { ConfirmSuccessEnterpriceComponent } from './components/confirm-success-enterprice/confirm-success-enterprice.component';
import { NotificationCmsComponent } from './components/notification-cms/notification-cms.component';
import { ChangePassswordFirsrtTimeComponent } from './components/change-passsword-firsrt-time/change-passsword-firsrt-time.component';
import { SignMessageDialogComponent } from './components/sign-message-dialog/sign-message-dialog.component';
import { NotifyWarningCustomComponent } from './components/notify-warning-custom/notify-warning-custom.component';
import { DowloadAppMobileComponent } from './components/dowload-app-mobile/dowload-app-mobile.component';
import { ResourceComponent } from './components/resource/resource.component';
import { AnonymousCloudCaComponent } from '../modules/login/anonymous-login/components/anonymous-cloud-ca/anonymous-cloud-ca.component';
import { AnonymousTwoFactorAuthenComponent } from '../modules/login/anonymous-login/components/anonymus-two-authen/anonymous-two-factor-authen.component';
import {EditAccountBrandnameComponent} from './components/edit-account-brandname/edit-account-brandname.component';
import { TrackEventDirective } from './directive/track-event.directive';
import { MysignSessionConfiguration } from './components/mysign-session-configuration/mysign-session-configuration.component';
import { SlideCaptchaComponent } from './components/slide-captcha/slide-captcha.component';
import { MobileCaptchaComponent } from '../modules/mobile-captcha/mobile-captcha.component';
import { LinkifyPipe } from './pipe/linkify.pipe';
import { ViewFilePdfImgComponent } from './components/view-file-pdf-img/view-file-pdf-img.component';
import { DowloadAppVNeIDMobileComponent } from './components/dowload-app-vneid-mobile/dowload-app-vneid-mobile.component';
import {WarningDataAuthenticationComponent} from './components/warning-data-authentication/warning-data-authentication.component';
import { ChooseSmsEventDialogComponent } from '../modules/dashboard/home/home-enterprise/document/choose-sms-event-dialog/choose-sms-event-dialog.component';
import { DowloadAppVContractComponent } from './components/dowload-app-vcontract-vneid/dowload-app-vcontract-vneid.component';
import {RequestConfirmIdentityComponent} from './components/request-confirm-identity/request-confirm-identity.component';
import {EnterIdentityVneidComponent} from './components/enter-identity-vneid/enter-identity-vneid.component';
import { ResultSignVneidPopupComponent } from './components/result-sign-vneid-popup/result-sign-vneid-popup.component';
import { PopupFaceMathEkycComponent } from './components/enter-identity-vneid/popup-face-math-ekyc/popup-face-math-ekyc.component';
import { ChooseImageModalComponent } from './components/enter-identity-vneid/components/choose-image/choose-image.component';
import { FaceDetectionComponent } from './components/enter-identity-vneid/components/face-detection/face-detection.component';
import { VNeIDVerifyingModalComponent } from './components/enter-identity-vneid/components/vneid-verifying-modal/vneid-verifying-modal.component';
import {SelectVersionDialogComponent} from '../shared/components/header/select-version-dialog/select-version-dialog.component';
import {SelectContractReviewDialogComponent} from '../shared/components/header/select-contract-review-dialog/select-contract-review-dialog.component';

@NgModule({
  declarations: [
    ErrorComponent,
    HeaderComponent,
    BreadcrumbsComponent,
    CheckInputNumberDirective,
    BytePipe,
    DateformatPipe,
    DateTime,
    DateYearMonthDayPipe,
    DateformatPipeTime,
    DateformatPipeTimeWithNoSeconds,
    TruncatePipe,
    NumericDirective,
    UploadMultiFileComponent,
    PdfViewerComponent,
    FocusFirstElementDirective,
    AutofocusDirective,
    CheckSpaceDirective,
    UploadFileComponent,
    CheckMiddleSpaceDirective,
    CheckUserNameDirective,
    CheckDepartmentCodeDirective,
    CheckProcedureNameDirective,
    CheckCertificateNoDirective,
    PageNotFoundComponent,
    PageErrorCodeComponent,
    PageAnnouncementComponent,
    PageErrorExpireComponent,
    FooterComponent,
    PaginationComponent,
    CheckPhoneDirective,
    EmailvalidatorDirective,
    EnterpriseSidebarComponent,
    HeaderSidebarComponent,
    ViewPdfComponent,
    CdkDetailRowDirective,
    ViewDocumentReferenceComponent,
    NotifyAlertComponent,
    NoSanitizePipe,
    DialogDraggableTitleDirective,
    DialogDraggableSpecialDirective,
    SautocompleteComponent,
    ChangePasswordComponent,
    DowloadAppMobileComponent,
    DowloadAppVNeIDMobileComponent,
    MustMatchDirective,
    PasswordPatternDirective,
    NotMatchDirective,
    DragAndDropFileDirective,
    PublicHeaderComponent,
    DragDropUploadComponent,
    ReplaceStringPipe,
    CurrencyMaskPipe,
    LandingpageHeaderComponent,
    LandingpageFooterComponent,
    LandingpageHeaderChildComponent,
    CounterDirective,
    CanvasComponent,
    PageNotFoundNoAccessComponent,
    ResetPasswordComponent,
    ResetPasswordExistsComponent,
    QuestionLoginComponent,
    ErpSContractComponent,
    WarningWithSkipComponent,
    MarkDownComponent,
    ClickOutsideDirective,
    WarningErrorFileComponent,
    ProcessingComponent,
    WarningSessionTimeoutComponent,
    NotifySessionTimeoutComponent,
    CheckParamDirective,
    NotifyWarningComponent,
    WarningHasTokenComponent,
    NotEnoughAlertComponent,
    WaringSignatureComponent,
    WarningNotChangeContractCodeComponent,
    ConfirmForwardComponent,
    AlertEkycComponent,
    FeedbackComponent,
    ResourceComponent,
    DocumentDownloadDialogComponent,
    DocumentDownloadSuccessDialogComponent,
    DocumentDownloadFalseDialogComponent,
    HandleTransactionResultDialogComponent,
    HandleTransactionDetailDialogComponent,
    NotifyExportDataCustomerComponent,
    NotifyExportDataCustomerSuccessComponent,
    KycCustomerInforComponent,
    SsoLoginWarningComponent,
    SmsWarningComponent,
    AddApproverDialogComponent,
    ApproveActionDialogComponent,
    ForwardSignDialogComponent,
    SelectVersionComponent,
    VerifyEnterpriceDialogComponent,
    ConfirmSuccessEnterpriceComponent,
    NotificationCmsComponent,
    ChangePassswordFirsrtTimeComponent,
    SignMessageDialogComponent,
    NotifyWarningCustomComponent,
    AnonymousCloudCaComponent,
    AnonymousTwoFactorAuthenComponent,
    EditAccountBrandnameComponent,
    TrackEventDirective,
    MysignSessionConfiguration,
    SlideCaptchaComponent,
    MobileCaptchaComponent,
    LinkifyPipe,
    ViewFilePdfImgComponent,
    WarningDataAuthenticationComponent,
    DowloadAppVContractComponent,
    RequestConfirmIdentityComponent,
    EnterIdentityVneidComponent,
    VNeIDVerifyingModalComponent,
    ResultSignVneidPopupComponent,
    PopupFaceMathEkycComponent,
    ChooseImageModalComponent,
    FaceDetectionComponent,
    ChooseSmsEventDialogComponent,
    SelectVersionDialogComponent,
    SelectContractReviewDialogComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    Ng4LoadingSpinnerModule.forRoot(),
    NgxExtendedPdfViewerModule,
    NgxMatSelectSearchModule,
    NgZorroAntdModule
  ],
  providers: [
    ConfirmDeactivateGuard,
  ],
    exports: [
        HeaderComponent,
        MaterialModule,
        MatFormFieldModule,
        BreadcrumbsComponent,
        CheckInputNumberDirective,
        BytePipe,
        DateformatPipe,
        DateformatPipeTime,
        DateYearMonthDayPipe,
        DateTime,
        DateformatPipeTimeWithNoSeconds,
        TruncatePipe,
        NumericDirective,
        UploadFileComponent,
        UploadMultiFileComponent,
        FocusFirstElementDirective,
        AutofocusDirective,
        CheckSpaceDirective,
        CheckMiddleSpaceDirective,
        CheckUserNameDirective,
        CheckDepartmentCodeDirective,
        CheckProcedureNameDirective,
        CheckCertificateNoDirective,
        PageNotFoundComponent,
        PageErrorCodeComponent,
        PageErrorExpireComponent,
        FooterComponent,
        PaginationComponent,
        CheckPhoneDirective,
        EmailvalidatorDirective,
        CdkDetailRowDirective,
        EnterpriseSidebarComponent,
        HeaderSidebarComponent,
        NotifyAlertComponent,
        NoSanitizePipe,
        DragDropModule,
        DialogDraggableTitleDirective,
        DialogDraggableSpecialDirective,
        NgxMatSelectSearchModule,
        SautocompleteComponent,
        PublicHeaderComponent,
        DragDropUploadComponent,
        ReplaceStringPipe,
        CurrencyMaskPipe,
        LandingpageHeaderComponent,
        LandingpageFooterComponent,
        LandingpageHeaderChildComponent,
        CounterDirective,
        CanvasComponent,
        PageNotFoundNoAccessComponent,
        QuestionLoginComponent,
        WarningWithSkipComponent,
        MarkDownComponent,
        ClickOutsideDirective,
        WarningErrorFileComponent,
        NotifyWarningComponent,
        CheckParamDirective,
        WarningHasTokenComponent,
        NotEnoughAlertComponent,
        WaringSignatureComponent,
        WarningNotChangeContractCodeComponent,
        ConfirmForwardComponent,
        DocumentDownloadDialogComponent,
        DocumentDownloadSuccessDialogComponent,
        DocumentDownloadFalseDialogComponent,
        HandleTransactionResultDialogComponent,
        HandleTransactionDetailDialogComponent,
        NotifyExportDataCustomerComponent,
        NotifyExportDataCustomerSuccessComponent,
        KycCustomerInforComponent,
        SsoLoginWarningComponent,
        SmsWarningComponent,
      SignMessageDialogComponent,
      AnonymousCloudCaComponent,
      AnonymousTwoFactorAuthenComponent,
      TrackEventDirective,
      SlideCaptchaComponent,
      MobileCaptchaComponent,
      LinkifyPipe,
      MustMatchDirective,
      ViewFilePdfImgComponent,
    ],
  entryComponents: [
    ViewPdfComponent,
    ViewDocumentReferenceComponent,
    ChangePasswordComponent,
    DowloadAppMobileComponent,
    DowloadAppVNeIDMobileComponent,
    ResetPasswordComponent,
    ResetPasswordExistsComponent,
    QuestionLoginComponent,
    WarningWithSkipComponent,
    WarningErrorFileComponent,
    WarningSessionTimeoutComponent,
    NotifySessionTimeoutComponent,
    NotifyWarningComponent,
    WarningHasTokenComponent,
    WaringSignatureComponent,
    WarningNotChangeContractCodeComponent,
    NotEnoughAlertComponent,
    ConfirmForwardComponent,
    FeedbackComponent,
    ResourceComponent,
    DocumentDownloadDialogComponent,
    DocumentDownloadSuccessDialogComponent,
    DocumentDownloadFalseDialogComponent,
    HandleTransactionResultDialogComponent,
    HandleTransactionDetailDialogComponent,
    NotifyExportDataCustomerComponent,
    NotifyExportDataCustomerSuccessComponent,
    KycCustomerInforComponent,
    SsoLoginWarningComponent,
    SmsWarningComponent,
    AddApproverDialogComponent,
    ApproveActionDialogComponent,
    ForwardSignDialogComponent,
    SelectVersionComponent,
    VerifyEnterpriceDialogComponent,
    ChangePassswordFirsrtTimeComponent,
    SignMessageDialogComponent,
    AnonymousCloudCaComponent,
    AnonymousTwoFactorAuthenComponent,
    EditAccountBrandnameComponent,
    MysignSessionConfiguration,
    SlideCaptchaComponent,
    ViewFilePdfImgComponent,
    WarningDataAuthenticationComponent,
    DowloadAppVContractComponent,
    RequestConfirmIdentityComponent,
    EnterIdentityVneidComponent,
    VNeIDVerifyingModalComponent,
    ResultSignVneidPopupComponent,
    PopupFaceMathEkycComponent,
    ChooseImageModalComponent,
    FaceDetectionComponent,
    ChooseSmsEventDialogComponent,
    SelectVersionDialogComponent,
    SelectContractReviewDialogComponent
  ]
})
export class SharedModule { }
